import gql from 'graphql-tag';

const Query = {};

const Mutation = {
  singleUpload: gql`
    mutation singleUpload($folderName: String!, $file: Upload!, $location: String) {
      singleUpload(folderName: $folderName, file: $file, location: $location) {
        public_url
      }
    }
  `,
  multiUpload: gql`
    mutation multiUpload($folderName: String!, $files: [Upload!]!, $location: String) {
      multiUpload(folderName: $folderName, files: $files, location: $location) {
        public_url
      }
    }
  `,
  uploadPropertyPictures: gql`
    mutation uploadPropertyPictures($propertyId: Int!, $opportunityId: Int, $files: [Upload!]!, $location: String) {
      uploadPropertyPictures(
        propertyId: $propertyId
        opportunityId: $opportunityId
        files: $files
        location: $location
      ) {
        public_url
      }
    }
  `,
  deletePropertyPicture: gql`
    mutation deletePropertyPicture($id: Int!, $opportunityId: Int) {
      deletePropertyPicture(id: $id, opportunityId: $opportunityId)
    }
  `,
  setPropertyPicturesOrder: gql`
    mutation setPropertyPicturesOrder($params: [propertyPictureOrderInput]) {
      setPropertyPicturesOrder(params: $params)
    }
  `,
  setPropertyPictureVisible: gql`
    mutation setPropertyPictureVisible($id: Int!, $isVisible: Boolean!) {
      setPropertyPictureVisible(id: $id, isVisible: $isVisible)
    }
  `,
  uploadContactInfosDocuments: gql`
    mutation uploadContactInfosDocuments(
      $contactInfoId: Int!
      $files: [Upload!]!
      $location: String
      $category: String
      $uniqueInCategory: Boolean
    ) {
      uploadContactInfosDocuments(
        contactInfoId: $contactInfoId
        files: $files
        location: $location
        category: $category
        uniqueInCategory: $uniqueInCategory
      ) {
        public_url
      }
    }
  `,
  uploadContactInfosProfilImage: gql`
    mutation uploadContactInfosProfilImage($contactInfoId: Int!, $files: [Upload!]!) {
      uploadContactInfosProfilImage(contactInfoId: $contactInfoId, files: $files) {
        public_url
      }
    }
  `,
  uploadContactDocuments: gql`
    mutation uploadContactDocuments($contactId: Int!, $files: [Upload!]!, $location: String) {
      uploadContactDocuments(contactId: $contactId, files: $files, location: $location) {
        public_url
      }
    }
  `,
  deleteContactDocument: gql`
    mutation deleteContactDocument($id: Int!) {
      deleteContactDocument(id: $id)
    }
  `,
  setContactDocumentsOrder: gql`
    mutation setContactDocumentsOrder($params: [contactDocumentOrderInput]) {
      setContactDocumentsOrder(params: $params)
    }
  `,
  setContactDocumentsType: gql`
    mutation setContactDocumentsType($params: [contactDocumentTypeInput]) {
      setContactDocumentsType(params: $params)
    }
  `,
  setContactDocumentVisible: gql`
    mutation setContactDocumentVisible($id: Int!, $isVisible: Boolean!) {
      setContactDocumentVisible(id: $id, isVisible: $isVisible)
    }
  `,
};

export default {
  Query,
  Mutation,
};
